import { styled } from "@pigment-css/react";
import { LockOutline } from "@acto/web-common/components";
import { useTranslations } from "@acto/web-common/locales";

const Notice = styled("div")(({ theme }) => ({
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[12],
  width: "100%",
  padding: theme.fieldSalesTwo.spacing[16],
  borderRadius: theme.fieldSalesTwo.radius[20],
  background: theme.fieldSalesTwo.colors.surface.glassMedium,
  border: `1px solid ${theme.fieldSalesTwo.colors.surface.glassBorder}`,
  backdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  WebkitBackdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  boxShadow: theme.fieldSalesTwo.shadows.glass,
}));

const IconChip = styled("div")(({ theme }) => ({
  flex: "0 0 auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 36,
  height: 36,
  borderRadius: theme.fieldSalesTwo.radius[10],
  background: "rgba(255,255,255,0.9)",
  color: theme.fieldSalesTwo.colors.neutral[900],
  "& svg": { width: 20, height: 20 },
}));

const Text = styled("p")(({ theme }) => ({
  flex: "1 1 0",
  minWidth: 0,
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[14],
  fontWeight: theme.fieldSalesTwo.font.weight[400],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[148],
  color: theme.fieldSalesTwo.colors.neutral[900],
  wordBreak: "break-word",
}));

export function LockedChatNotice() {
  const tChat = useTranslations("chat");

  return (
    <Notice>
      <IconChip>
        <LockOutline aria-hidden="true" />
      </IconChip>
      <Text>{tChat("chatCannotBeContinued")}</Text>
    </Notice>
  );
}
